import { useState, useEffect } from 'react';
import firebase from 'firebase/app';

/**
 * The delegation grants of a SPECIFIC user: users/{uid}/client_roles, live.
 * Unlike useClientRoles (which derives the list from the SIGNED-IN user), this
 * reads whoever you ask about — the admin surface uses it to show what a
 * client's owner sees on their own home. Admin-readable by the 2026-08-11
 * rules (owner or Strike admin only).
 */
export function useClientRolesForUser(uid) {
    const [roles, setRoles] = useState(null);

    useEffect(() => {
        if (!uid) { setRoles(null); return undefined; }
        const unsubscribe = firebase.firestore()
            .collection('users').doc(uid).collection('client_roles')
            .onSnapshot(
                (snap) => setRoles(snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }))),
                (err) => {
                    console.warn('[useClientRolesForUser] listen failed:', err && err.message);
                    setRoles([]);
                },
            );
        return unsubscribe;
    }, [uid]);

    return roles;
}
